import type { FiltersToApply } from "types/filters";
import type { AppliedFilterItem } from "ui/data-grid/components/applied-filters/applied-filters.types";

export type AppliedFilterChip = AppliedFilterItem & {
  filterId: string;
  value: string;
};

/** The fallback for a value with no label of its own: `IN_PERSON`, `in-person` → `In Person`. */
export const formatFilterValue = (value: string): string =>
  value
    .toLowerCase()
    .split(/[_\s-]+/)
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");

export const toAppliedFilterChips = (
  filtersToApply: FiltersToApply,
  filterIdToTitle: Record<string, string>,
  filterValueToLabel?: Record<string, string>,
): AppliedFilterChip[] =>
  Object.entries(filtersToApply).flatMap(([filterId, values = []]) =>
    values.map((value) => {
      const title = filterIdToTitle[filterId];
      const valueLabel = filterValueToLabel?.[value] ?? formatFilterValue(value);

      return {
        id: JSON.stringify([filterId, value]),
        filterId,
        value,
        label: title ? `${title}: ${valueLabel}` : valueLabel,
      };
    }),
  );

export const withoutFilterValue = <TFilters extends FiltersToApply>(
  filtersToApply: TFilters,
  filterId: string,
  value: string,
): TFilters => ({
  ...filtersToApply,
  [filterId]: (filtersToApply[filterId] ?? []).filter((selected) => selected !== value),
});
